import styled, { css } from "styled-components";
import { theme } from "../../../constants/StyledComponents";

const StyledTextAreaContainer = styled.div<{
  $readOnly?: boolean;
  disabled?: boolean;
  $hasError?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid
    ${(props) =>
      props.disabled
        ? theme.colors.grey_4
        : props.$hasError
          ? theme.colors.red_1
          : theme.colors.black};
  background-color: ${theme.colors.white};
  border-radius: ${theme.variables.border_radius_1};
  position: relative;

  ${({ disabled }) =>
    disabled &&
    css`
      &,
      & * {
        cursor: not-allowed !important;
      }
    `}

  &:focus-within label {
    transform: translate(2px, 4px) scale(0.8) !important;
  }

  &:focus-within {
    border-color: ${theme.colors.purple};
  }
`;

const StyledTextArea = styled.textarea<{
  disabled?: boolean;
  readOnly?: boolean;
  $hasLabel?: boolean;
}>`
  resize: none;
  background-color: transparent;
  outline: 0;
  border: 0;
  min-height: 48px;
  height: auto;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: ${(props) => (props.$hasLabel ? "0" : "12")}px 12px 12px 12px;
  color: ${theme.colors.black};
  font-family: ${theme.variables.font_family};
  font-size: ${theme.variables.fs_14};
  font-weight: ${theme.variables.fw_Regular};
  cursor: ${(props) =>
    props.disabled ? "not-allowed" : props.readOnly ? "inherit" : "text"};

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    border-radius: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &:focus {
    outline: 0;
    outline-offset: 0;
    border-color: transparent;
    --tw-ring-offset-width: 0;
  }

  &:-webkit-autofill + label {
    transform: translate(2px, 4px) scale(0.8) !important;
  }
`;

const StyledLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: transparent;
  width: 100%;
`;

const StyledLabel = styled.label<{ $hasError?: boolean; $isActive: boolean }>`
  color: ${(props) =>
    props.$hasError ? theme.colors.red_1 : theme.colors.grey_2};
  pointer-events: none;
  padding-left: 12px;
  transform-origin: top left;
  transition: all 0.2s ease-out;
  font-family: ${theme.variables.font_family};
  font-size: ${theme.variables.fs_14};
  font-weight: ${theme.variables.fw_Regular};
  transform: ${(props) =>
    props.$isActive
      ? "translate(2px, 4px) scale(0.8)"
      : "translate(0, 12px) scale(1)"};
`;

const StyledFieldContainer = styled.div<{
  $hasError?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$hasError ? "8px" : "0")};
  width: 100%;
  align-items: start;
`;

const StyledTextCounter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 7px;
`;

export {
  StyledTextArea,
  StyledLabel,
  StyledTextAreaContainer,
  StyledFieldContainer,
  StyledLabelContainer,
  StyledTextCounter,
};
